export enum InvitationStatus {
  JOINED = 'joined',
  PENDING = 'pending',
  CANCELED = 'canceled',
}
